var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 17.875C7.875 17.25 8.61499 16.9375 9.47 16.9375C10.3233 16.9375 11.0625 17.25 11.6875 17.875L30 36.1875L48.375 17.8125C48.9583 17.2292 49.6875 16.9375 50.5625 16.9375C51.4375 16.9375 52.1875 17.25 52.8125 17.875C53.4375 18.5 53.75 19.24 53.75 20.095C53.75 20.9483 53.4375 21.6875 52.8125 22.3125L31.75 43.3125C31.5 43.5625 31.2292 43.74 30.9375 43.845C30.6458 43.9483 30.3333 44 30 44C29.6667 44 29.3542 43.9483 29.0625 43.845C28.7708 43.74 28.5 43.5625 28.25 43.3125L7.1875 22.25C6.60416 21.6667 6.3125 20.9483 6.3125 20.095C6.3125 19.24 6.625 18.5 7.25 17.875Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrowDownIcon.60fdc6d028a962b94211012cba00b0db.svg";
export { ForwardRef as ReactComponent };